import {Routes} from '@angular/router';

export const equitySaleRoutes: Routes = [
  {
    path: 'equity.sale.order',
    loadComponent: () => import('./equity.sale.order.component').then(m => m.EquitySaleOrderComponent),
    data: { title: '权益销售单' },
    children: [
      {
        path: '',
        loadComponent: () => import('./list.order/list.order.component').then(m => m.ListOrderComponent),
        data: {title: "权益销售单"},
      },
      {
        path: 'add.sale.order',
        loadComponent: () => import('./add.sale.order/add.sale.order.component').then(m => m.AddSaleOrderComponent),
        data: { title: '权益销售单明细' },
      },
      {
        path: 'add.sale.order/:orderId',
        loadComponent: () => import('./add.sale.order/add.sale.order.component').then(m => m.AddSaleOrderComponent),
        data: { title: '权益销售单明细' },
      },
    ]
  },
];
